import React from 'react'
import { T } from '@transifex/react'
import { Box, Text } from '@lightspeed/design-system-react'
import { useFulfillmentTakeNowSaleData } from '../useFulfillmentTakeNowSaleData'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'

export const TakeNowAndFulfillmentRemainingBalanceSection = () => {
  const {
    takeNowItemsBalance,
    payLaterBalance,
    shouldShowGroupingOfSaleLines,
    remainingBalance,
    shouldShowComplexSaleBalanceBreakdown,
  } = useFulfillmentTakeNowSaleData()
  const formatCurrencyValue = useFormatCurrencyValue()

  if (!shouldShowGroupingOfSaleLines) {
    return null
  }

  return (
    <Box
      className="sale-summary-section total-remaining-section"
      data-testid="total-remaining-section"
    >
      <ul className="sale-summary-list">
        <li className="sale-summary-line">
          <Text
            tag="div"
            type="signpost"
            className="sale-summary-line-item sale-summary-line-item--label"
          >
            <T
              _str="Total remaining"
              _context="Total remaining label in take now and fulfillment balance breakdown"
            />
          </Text>
          <Text
            tag="div"
            type="intro"
            className="sale-summary-line-item sale-summary-line-item--value"
          >
            {formatCurrencyValue(remainingBalance)}
          </Text>
        </li>
      </ul>
      {shouldShowComplexSaleBalanceBreakdown &&
      payLaterBalance !== undefined ? (
        <Box className="sale-summary-section sale-summary-section--indent">
          <ul className="sale-summary-list">
            <li className="sale-summary-line">
              <Text
                tag="div"
                className="sale-summary-line-item sale-summary-line-item--label"
              >
                <T
                  _str="Pay now"
                  _context="Pay now label in take now and fulfillment balance breakdown"
                />
              </Text>
              <Text
                tag="div"
                className="sale-summary-line-item sale-summary-line-item--value"
              >
                {formatCurrencyValue(takeNowItemsBalance)}
              </Text>
            </li>
            <li className="sale-summary-line vd-pt4">
              <Text
                tag="div"
                className="sale-summary-line-item sale-summary-line-item--label"
              >
                <T
                  _str="Pay later"
                  _context="Pay later label in take now and fulfillment balance breakdown"
                />
              </Text>
              <Text
                tag="div"
                className="sale-summary-line-item sale-summary-line-item--value"
              >
                {formatCurrencyValue(payLaterBalance)}
              </Text>
            </li>
          </ul>
        </Box>
      ) : null}
    </Box>
  )
}
